import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';
import OrganizationServer from "@/api/organization";

export const DICTIONARY_FACTORY_ORG_COMPANY = 'org_company';
export const DICTIONARY_FACTORY_ORG_COMPANY_TYPE_VALID = 'VALID';
export const DICTIONARY_FACTORY_ORG_COMPANY_TYPE_ALL = 'ALL';
export default class OrgCompanyDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ORG_COMPANY});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ORG_COMPANY_TYPE_VALID: {
                let companies = [];
                let response = await OrganizationServer.company.list({eq_status: '1'});
                if (response.data.code === '200') {
                    companies = response.data.data;
                }
                dictionary = new Dictionary({items: companies, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ORG_COMPANY_TYPE_ALL: {
                let companies = [];
                let response = await OrganizationServer.company.list({});
                if (response.data.code === '200') {
                    companies = response.data.data;
                }
                dictionary = new Dictionary({items: companies, valueKey: 'id', textKey: 'name'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}